import React, { createContext, useState } from 'react';

const ThemeContext = createContext(false)

const ThemeProvider = ({ children }) => {
    const [drawerSilde, setDrawerSilde] = useState(true)
    const [bodySilde, setBodySilde] = useState(true)

    const toggleDrawerFun = () => {
        setDrawerSilde(!drawerSilde)
    }

    const toggleBodyFun = () => {
        setBodySilde(!bodySilde)
    }

    return (
        <ThemeContext.Provider value={{
            drawerSilde: drawerSilde,
            bodySilde: bodySilde,
            setDrawerSilde: setDrawerSilde,

            toggleBodyFun: toggleBodyFun,
            toggleDrawerFun: toggleDrawerFun
        }}>
            {children}
        </ThemeContext.Provider>
    )
}

export { ThemeContext, ThemeProvider };

